export const toTitleCase = (str?: string): string => {
  if (!str) {
    return '';
  }

  return str
    .split('_')
    .join(' ')
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const toTitleCaseID = (str?: string): string => {
  if (!str) {
    return '';
  }

  return str
    .split('_')
    .join(' ')
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + (word.length > 2 ? word.slice(1) : word.slice(1).toUpperCase()))
    .join(' ');
};
